import { defineComponent as p, createElementBlock as i, openBlock as e, normalizeClass as n, createVNode as s, createElementVNode as c, createBlock as d, createCommentVNode as m, createTextVNode as u, toDisplayString as r, unref as C } from "vue";
import { _ } from "./UiFlagIcon.vue_vue_type_script_setup_true_lang-kwJ9_1c-.js";
/* empty css                                                    */
import "./vue3-lottie.es-BQlzj7s3.js";
import "./style-R_nxVIjQ.js";
import { _ as g } from "./UiIcon.vue_vue_type_script_setup_true_lang-BEUNoCyM.js";
/* empty css                                                */
/* empty css                                                         */
/* empty css                                                    */
import "./useDatePicker-DAFR8Jnp.js";
import "../config/index.js";
/* empty css                                                           */
/* empty css                                                       */
/* empty css                                                   */
/* empty css                                                  */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                  */
/* empty css                                                      */
import "vue-router";
/* empty css                                                */
/* empty css                                                 */
/* empty css                                                      */
/* empty css                                                        */
/* empty css                                                    */
/* empty css                                                */
/* empty css                                                    */
/* empty css                                                               */
/* empty css                                                    */
const f = { key: 0 }, W = /* @__PURE__ */ p({
  __name: "UiLanguageButton",
  props: {
    locale: {},
    selected: {}
  },
  emits: ["change"],
  setup(k, { emit: a }) {
    const l = a;
    return (o, t) => (e(), i("button", {
      onClick: t[0] || (t[0] = (N) => l("change", o.locale)),
      key: o.locale?.isoCode,
      class: n(["ui-languages--modal__item", { "is-active": o.locale?.isoCode === o.selected?.isoCode }])
    }, [
      s(_, {
        class: "ui-languages--modal__item__flag",
        isoCode: o.locale?.isoCode ?? ""
      }, null, 8, ["isoCode"]),
      c("span", null, [
        u(r(o.locale.name) + " ", 1),
        o.locale?.nativeName ? (e(), i("span", f, " (" + r(o.locale?.nativeName) + ")", 1)) : m("", !0)
      ]),
      o.locale?.isoCode === o.selected?.isoCode ? (e(), d(C(g), {
        key: 0,
        color: "var(--color-icon-accent)",
        name: "done",
        type: "400"
      })) : m("", !0)
    ], 2));
  }
});
export {
  W as _
};
